export default __webpack_public_path__ + "static/media/E08.7a0e9eab.mp3";